import { Controller } from '@hotwired/stimulus';
/* global $, _ */

const PRICING_GROUPS = ['travel_helper', 'misc', 'travel_expense', 'arrangement_fee'];
const HIDDEN_STYLE = 'none';
const COCOON_CONTAINER = '.js-tour-quotation-details';

const parsePrice = (text) => {
  const str = String(text).trim();
  const isNegative = str.startsWith('-');
  const digits = str.replace(/[^\d]/g, '');
  const value = parseInt(digits, 10) || 0;
  return isNegative ? -value : value;
};

export default class extends Controller {
  static targets = ['totalAmount', 'itemPrice'];

  connect() {
    this.setupEventListeners();
    this.recalculateAll();
  }

  disconnect() {
    $(this.element)
      .find(COCOON_CONTAINER)
      .off('cocoon:after-insert')
      .off('cocoon:after-remove');
  }

  setupEventListeners() {
    this.handlePriceUpdate = _.debounce(this.recalculateAll.bind(this), 100);

    $(this.element)
      .find(COCOON_CONTAINER)
      .on('cocoon:after-insert', () => this.handlePriceUpdate())
      .on('cocoon:after-remove', () => this.handlePriceUpdate());
  }

  recalculateAll() {
    requestAnimationFrame(() => {
      this.updateGroupSubtotals();
      this.updateTotalAmount();
    });
  }

  updateGroupSubtotals() {
    PRICING_GROUPS.forEach((groupNumber) => {
      const subtotal = this.calculateGroupSubtotal(groupNumber);
      this.updateSubtotalDisplay(groupNumber, subtotal);
    });
  }

  calculateGroupSubtotal(groupNumber) {
    return this.itemPriceTargets
      .filter((element) => {
        const row = element.closest('.nested-fields');
        if (!row || !row.offsetParent) return false;

        const hiddenInput = row.querySelector('input[name*="[group_number]"]');
        return hiddenInput && hiddenInput.value === groupNumber.toString();
      })
      .reduce((sum, el) => sum + parsePrice(el.textContent), 0);
  }

  updateSubtotalDisplay(groupNumber, subtotal) {
    const element = this.element.querySelector(
      `.js-group-subtotal[data-group-number="${groupNumber}"]`,
    );
    if (element) {
      element.textContent = subtotal.toLocaleString();
    }
  }

  updateTotalAmount() {
    if (!this.hasTotalAmountTarget) return;

    const subtotals = this.element.querySelectorAll('.js-group-subtotal');
    const total = Array.from(subtotals).reduce(
      (sum, el) => sum + parsePrice(el.textContent),
      0,
    );

    this.totalAmountTarget.textContent = total.toLocaleString();
  }
}
